import script from "./MainMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./MainMenu.vue?vue&type=script&setup=true&lang=js"

import "./MainMenu.vue?vue&type=style&index=0&id=446297ec&scoped=true&lang=css"

import exportComponent from "/vercel/path0/cv-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-446297ec"]])

export default __exports__